import {
  SEGMENT_STYLE_CONFIG,
  SegmentStyleConfig,
} from '@entities/rfm/model/constants'
import type { SegmentType } from '@shared/api/rtkQuery'

export const segmentStyleConfigMap = new Map<SegmentType, SegmentStyleConfig>(
  SEGMENT_STYLE_CONFIG.map(item => [item.segmentType, item])
)
